import { useContext } from "react";
import { OrganisationPledgesContext } from "../components/context/organisation-pledges.context";
export const useOrganisationPledges = () => (useContext(OrganisationPledgesContext) || []);